import { createApiClient } from './client';
import { tokenStorage } from '../auth/storage';

const baseUrl = import.meta.env.VITE_API_BASE_URL ?? 'https://api.runpavlov.ai';

export const api = createApiClient({ baseUrl, getToken: () => tokenStorage.get() });
export * from './client';
